/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.addEventListener("DOMContentLoaded", function () {
  // lazy load video
  const videos = document.querySelectorAll("video[data-src]");
  if (window.IntersectionObserver) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          console.log({ aspect: entry.intersectionRatio });
          const target = entry.target;
          if (entry.isIntersecting) {
            target.src = target.getAttribute("data-src");
            target.poster = target.getAttribute("data-poster");
            target.setAttribute("data-lazy", true);
            observer.unobserve(target);
          }
        });
      },
      {
        rootMargin: "70px 0px",
      }
    );
    videos.forEach((video) => {
      observer.observe(video);
    });
  } else {
    videos.forEach((video) => {
      video.src = video.getAttribute("data-src");
      video.poster = video.getAttribute("data-poster");
    });
  }
});

// 买赠 js start
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
var CustomCurrency = (function () {
  function CustomCurrency() {
    _classCallCheck(this, CustomCurrency);
  }

  _createClass(CustomCurrency, null, [
    {
      key: "formatMoney",
      value:
        /**
         * Format money values based on your shop currency settings
         *
         * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents or 3.00 dollars
         * @param  {String} format - shop money_format setting
         * @return {String} value - formatted value
         */
        function formatMoney(cents, format) {
          if (typeof cents === "string") {
            cents = cents.replace(".", "");
          }

          var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || "${{amount}}";

          function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
          }

          function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultTo(precision, 2);
            thousands = defaultTo(thousands, ",");
            decimal = defaultTo(decimal, ".");

            if (isNaN(number) || number == null) {
              return 0;
            }

            number = (number / 100.0).toFixed(precision);
            var parts = number.split("."),
              dollarsAmount = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                "$1" + thousands
              ),
              centsAmount = parts[1] ? decimal + parts[1] : "";
            return dollarsAmount + centsAmount;
          }

          var value = "";

          switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
              value = formatWithDelimiters(cents, 2);
              break;

            case "amount_no_decimals":
              value = formatWithDelimiters(cents, 0);
              break;

            case "amount_with_space_separator":
              value = formatWithDelimiters(cents, 2, " ", ".");
              break;

            case "amount_no_decimals_with_comma_separator":
              value = formatWithDelimiters(cents, 0, ",", ".");
              break;

            case "amount_no_decimals_with_space_separator":
              value = formatWithDelimiters(cents, 0, " ");
              break;

            case "amount_with_comma_separator":
              value = formatWithDelimiters(cents, 2, ".", ",");
              break;
          }

          if (formatString.indexOf("with_comma_separator") !== -1) {
            return formatString.replace(placeholderRegex, value);
            // .replace(",00", "");
          } else {
            return formatString.replace(placeholderRegex, value);
            // .replace(".00", "");
          }
        },
    },
  ]);

  return CustomCurrency;
})();

function createDiscountDialog(giftInfo) {
  const currencyFormat = window.theme.currencyCodeEnabled
    ? window.theme.moneyWithCurrencyFormat
    : window.theme.moneyFormat;
  const minPrice = CustomCurrency.formatMoney(
    giftInfo.minPrice * 100,
    currencyFormat
  );
  const zeroPrice = CustomCurrency.formatMoney(0, currencyFormat);
  const dialog = document.createElement("div");
  dialog.classList.add("discount-dialog-root");
  dialog.innerHTML = `
    <div class="discount-modal-root">
      <div class="discount-modal-overlay"></div>
      <div class="discount-modal-container">
        <div class="discount-modal-modal">
          <div class="discount-dialog-container">
            <div class="discount-dialog-conent">
              <div class="discount-dialog-customContent">
                <div class="discount-dialog-inner">
                  <div class="discount-dialog-close">
                    <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 16px; height: 16px;">
                      <path d="m9.414 8 6.293-6.293A1 1 0 0 0 14.293.293L8 6.586 1.707.293A1 1 0 1 0 .293 1.707L6.586 8 .293 14.293a1 1 0 1 0 1.414 1.414L8 9.414l6.293 6.293a.997.997 0 0 0 1.631-.324 1 1 0 0 0-.217-1.09L9.414 8Z" fill="#6C6B80"></path>
                    </svg>
                  </div>
                  <div class="discount-dialog-mainpic">
                    <img src="${giftInfo.img}" alt="discount-dialog-mainpic">
                  </div>
                  <div class="discount-dialog-desc">
                    <div class="discount-dialog-desc__icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="26" viewBox="0 0 32 26" fill="none">
                        <path d="M24.3932 23.832C24.842 23.832 25.2057 23.4683 25.2057 23.0195V11.6445C25.2057 11.1958 24.842 10.832 24.3932 10.832H7.60156C7.15283 10.832 6.78906 11.1958 6.78906 11.6445V23.0195C6.78906 23.4683 7.15283 23.832 7.60156 23.832H24.3932Z" fill="url(#paint0_linear_1001_2296)" stroke="url(#paint1_linear_1001_2296)" stroke-width="1.625" stroke-linecap="square" stroke-linejoin="round"/>
                        <path d="M16 23.832V10.832" stroke="url(#paint2_linear_1001_2296)" stroke-width="1.625" stroke-linecap="square" stroke-linejoin="round"/>
                        <g filter="url(#filter0_d_1001_2296)">
                        <path d="M26.8307 6.5H5.16406V10.8333H26.8307V6.5Z" fill="url(#paint3_linear_1001_2296)"/>
                        <path d="M26.8307 6.5H5.16406V10.8333H26.8307V6.5Z" stroke="url(#paint4_linear_1001_2296)" stroke-width="1.625" stroke-linecap="square" stroke-linejoin="round"/>
                        </g>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0895 1.59344C11.4068 1.27614 11.9213 1.27614 12.2386 1.59344L15.9974 5.35225L19.7562 1.59344C20.0735 1.27614 20.588 1.27614 20.9053 1.59344C21.2226 1.91075 21.2226 2.42519 20.9053 2.74249L16.5719 7.07583C16.2546 7.39313 15.7402 7.39313 15.4229 7.07583L11.0895 2.74249C10.7722 2.42519 10.7722 1.91075 11.0895 1.59344Z" fill="#FF7920" stroke="url(#paint5_linear_1001_2296)" stroke-width="1.625" stroke-linecap="round" stroke-linejoin="round"/>
                        <defs>
                        <filter id="filter0_d_1001_2296" x="0.776562" y="3.7375" width="30.443" height="13.108" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="1.625"/>
                        <feGaussianBlur stdDeviation="1.7875"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.4 0 0 0 0 0 0 0 0 0.24 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1001_2296"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1001_2296" result="shape"/>
                        </filter>
                        <linearGradient id="paint0_linear_1001_2296" x1="15.9974" y1="10.832" x2="15.9974" y2="23.832" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#FF6600"/>
                        <stop offset="1" stop-color="#FF8737"/>
                        </linearGradient>
                        <linearGradient id="paint1_linear_1001_2296" x1="15.9974" y1="10.832" x2="15.9974" y2="23.832" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#FF6906"/>
                        <stop offset="1" stop-color="#FF8838"/>
                        </linearGradient>
                        <linearGradient id="paint2_linear_1001_2296" x1="16" y1="17.332" x2="17" y2="17.332" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#FEF2ED"/>
                        </linearGradient>
                        <linearGradient id="paint3_linear_1001_2296" x1="15.9974" y1="6.5" x2="15.9974" y2="10.8333" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#FF7214"/>
                        <stop offset="1" stop-color="#FF8E43"/>
                        </linearGradient>
                        <linearGradient id="paint4_linear_1001_2296" x1="15.9995" y1="6.5" x2="15.9995" y2="9.75" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#FF7214"/>
                        <stop offset="1" stop-color="#FF8838"/>
                        </linearGradient>
                        <linearGradient id="paint5_linear_1001_2296" x1="15.9974" y1="1.35547" x2="15.9995" y2="8.93854" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#FF7214"/>
                        <stop offset="1" stop-color="#FF7B23"/>
                        </linearGradient>
                        </defs>
                        </svg>
                    </div>
                    <div class="discount-dialog-desc__text">${giftInfo.desc}</div>
                  </div>
                  <div class="discount-dialog-quantity">x${giftInfo.yNum}</div>
                  <div class="discount-dialog-price">
                    <div class="discount-dialog-price__newPrice">${zeroPrice}</div>
                    <div class="discount-dialog-price__oldPrice">${minPrice}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(dialog);
  document.body.style.overflow = "hidden";

  const closeBtn = dialog.querySelector(".discount-dialog-close");
  closeBtn.addEventListener("click", () => {
    closeDiscountDialog();
  });
}
function closeDiscountDialog() {
  const dialog = document.querySelector(".discount-dialog-root");
  if (dialog) {
    dialog.remove();
    document.body.style.overflow = "auto";
  }
}
function createDiscountTip(nowItem) {
  const discountTip = document.createElement("div");
  discountTip.classList.add("discountTip");
  discountTip.innerHTML = `
    <div class="discountTip__icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
        <path d="M15.1654 14.666C15.4415 14.666 15.6654 14.4422 15.6654 14.166V7.16602C15.6654 6.88987 15.4415 6.66602 15.1654 6.66602H4.83203C4.55589 6.66602 4.33203 6.88987 4.33203 7.16602V14.166C4.33203 14.4422 4.55589 14.666 4.83203 14.666H15.1654Z" fill="url(#paint0_linear_1001_2290)" stroke="url(#paint1_linear_1001_2290)" stroke-linecap="square" stroke-linejoin="round"/>
        <path d="M10 14.666V6.66602" stroke="url(#paint2_linear_1001_2290)" stroke-linecap="square" stroke-linejoin="round"/>
        <g filter="url(#filter0_d_1001_2290)">
        <path d="M16.6654 4H3.33203V6.66667H16.6654V4Z" fill="url(#paint3_linear_1001_2290)"/>
        <path d="M16.6654 4H3.33203V6.66667H16.6654V4Z" stroke="url(#paint4_linear_1001_2290)" stroke-linecap="square" stroke-linejoin="round"/>
        </g>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.97848 0.980431C7.17374 0.785169 7.49032 0.785169 7.68558 0.980431L9.9987 3.29354L12.3118 0.980431C12.5071 0.785169 12.8237 0.785169 13.0189 0.980431C13.2142 1.17569 13.2142 1.49228 13.0189 1.68754L10.3523 4.3542C10.157 4.54947 9.84041 4.54947 9.64514 4.3542L6.97848 1.68754C6.78322 1.49228 6.78322 1.17569 6.97848 0.980431Z" fill="#FF7920" stroke="url(#paint5_linear_1001_2290)" stroke-linecap="round" stroke-linejoin="round"/>
        <defs>
        <filter id="filter0_d_1001_2290" x="0.632031" y="2.3" width="18.732" height="8.06699" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="1"/>
        <feGaussianBlur stdDeviation="1.1"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.4 0 0 0 0 0 0 0 0 0.24 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1001_2290"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1001_2290" result="shape"/>
        </filter>
        <linearGradient id="paint0_linear_1001_2290" x1="9.9987" y1="6.66602" x2="9.9987" y2="14.666" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FF6600"/>
        <stop offset="1" stop-color="#FF8737"/>
        </linearGradient>
        <linearGradient id="paint1_linear_1001_2290" x1="9.9987" y1="6.66602" x2="9.9987" y2="14.666" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FF6906"/>
        <stop offset="1" stop-color="#FF8838"/>
        </linearGradient>
        <linearGradient id="paint2_linear_1001_2290" x1="10" y1="10.666" x2="11" y2="10.666" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FEF2ED"/>
        </linearGradient>
        <linearGradient id="paint3_linear_1001_2290" x1="9.9987" y1="4" x2="9.9987" y2="6.66667" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FF7214"/>
        <stop offset="1" stop-color="#FF8E43"/>
        </linearGradient>
        <linearGradient id="paint4_linear_1001_2290" x1="10" y1="4" x2="10" y2="6" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FF7214"/>
        <stop offset="1" stop-color="#FF8838"/>
        </linearGradient>
        <linearGradient id="paint5_linear_1001_2290" x1="9.9987" y1="0.833984" x2="10" y2="5.50049" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FF7214"/>
        <stop offset="1" stop-color="#FF7B23"/>
        </linearGradient>
        </defs>
      </svg>
    </div>
    <div class="discountTip__text">ログイン後、ご購入で無料プレゼント</div>
    <div class="discountTip__openTip">
      <div class="discountTip__openTip__text">Check out</div>
      <div class="discountTip__openTip__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M7.91602 5L12.916 10L7.91602 15" stroke="#F06E17" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  `;
  return discountTip;
}
function getRandomInt(min, max) {
  // Math.random() 生成一个 0 到 1 之间的随机数
  // (max - min + 1) 确保范围包括 max
  // Math.floor() 对结果进行向下取整
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
function deepCopy(obj) {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }

  if (Array.isArray(obj)) {
    const arrCopy = [];
    for (let i = 0; i < obj.length; i++) {
      arrCopy[i] = deepCopy(obj[i]);
    }
    return arrCopy;
  }

  const objCopy = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      objCopy[key] = deepCopy(obj[key]);
    }
  }
  return objCopy;
}

window.DISCOUNT = {
  list: window.DISCOUNTList || [],
  getAllActiveDiscount: function () {
    const temp = this.list.filter((item) => item.status !== "EXPIRED");
    return temp.filter((item) => item.automaticDiscount.status === "ACTIVE");
  },
  isDiscountProduct: function (id) {
    const temp = this.getAllActiveDiscount();
    const index = temp.collectionInfo.ids.findIndex((ite) => ite === id);
    return index !== -1;
  },
  isDiscountVariant: function (type, productId, variantId) {
    const temp = this.getAllActiveDiscount();
    let nowItem = undefined;
    for (let i = 0; i < temp.length; i++) {
      const item = temp[i];
      let products = [];
      let variants = [];
      if (type === "x") {
        products =
          item.automaticDiscount.customerBuys.items.products.edges || [];
        variants =
          item.automaticDiscount.customerBuys.items.productVariants.edges || [];
      } else {
        products =
          item.automaticDiscount.customerGets.items.products.edges || [];
        variants =
          item.automaticDiscount.customerGets.items.productVariants.edges || [];
      }

      const productIds = products.map((item) => {
        const productId = item.node.id;
        return productId.split("/").pop() || "";
      });
      if (productIds.includes(productId.toString())) {
        nowItem = item;
        break;
      }

      const variantIds = variants.map((item) => {
        const variantId = item.node.id;
        return variantId.split("/").pop() || "";
      });
      if (variantIds.includes(variantId.toString())) {
        nowItem = item;
        break;
      }
    }
    return nowItem;
  },
  productDetailShow: function (prodictId, variantId) {
    const nowItem = this.isDiscountVariant("x", prodictId, variantId);
    // console.log("productDetailShow", prodictId, variantId, nowItem);
    const productMetaDom = document.querySelector(".ProductMeta");
    const discountTipDom = productMetaDom.querySelector(".discountTip");
    if (!nowItem) {
      if (discountTipDom) {
        productMetaDom.removeChild(discountTipDom);
      }
    } else {
      // clear old discount tip
      if (discountTipDom) {
        productMetaDom.removeChild(discountTipDom);
      }
      // add discount tip
      const discountTip = createDiscountTip(nowItem);
      productMetaDom.appendChild(discountTip);

      // add click event
      discountTip.addEventListener("click", () => {
        createDiscountDialog(nowItem.giftInfo);
      });
    }
  },
  getAllGetsCanBuys: function (item) {
    const goods = [];
    const productVariants =
      item.automaticDiscount.customerGets.items.productVariants.edges || [];
    productVariants.forEach((productVariant) => {
      const variantId = productVariant.node.id;
      const variant = {
        product_id: productVariant.node.product.id.split("/").pop(),
        id: variantId.split("/").pop(),
        sku: productVariant.node.sku,
      };
      goods.push(variant);
    });
    const products =
      item.automaticDiscount.customerGets.items.products.edges || [];
    products.forEach((item) => {
      const productId = item.node.id;
      const lastProductId = productId.split("/").pop();
      item.node.variants.edges.forEach((variant) => {
        const variantId2 = variant.node.id;
        const variant2 = {
          product_id: lastProductId,
          id: variantId2.split("/").pop(),
          sku: variant.node.sku,
        };
        goods.push(variant2);
      });
    });
    return goods;
  },
  // TODO: add to cart isTriggerDiscount
  addToCartIsTriggerDiscount: async function (cartInfo) {
    console.log({ cartInfo });
    const activeDiscounts = deepCopy(this.getAllActiveDiscount());
    cartInfo.items.forEach((item) => {
      const buyitem = this.isDiscountVariant(
        "x",
        item.product_id,
        item.variant_id
      );
      const getitem = this.isDiscountVariant(
        "y",
        item.product_id,
        item.variant_id
      );

      if (buyitem) {
        const index = activeDiscounts.findIndex(
          (item) => item.id === buyitem.id
        );
        if (index !== -1) {
          if (!activeDiscounts[index].computedCart) {
            activeDiscounts[index].computedCart = {
              xNum: 0,
              yNum: 0,
              xskus: [],
            };
          }
          activeDiscounts[index].computedCart.xNum += item.quantity;
          activeDiscounts[index].computedCart.xskus.push(item.sku);
          console.log({ a: activeDiscounts[index] });
        }
      }
      if (getitem) {
        const index = activeDiscounts.findIndex(
          (item) => item.id === getitem.id
        );
        if (index !== -1) {
          if (!activeDiscounts[index].computedCart) {
            activeDiscounts[index].computedCart = {
              xNum: 0,
              yNum: 0,
              xskus: [],
            };
          }
          activeDiscounts[index].computedCart.yNum += item.quantity;
        }
      }
    });

    let tempCart = [];
    activeDiscounts.forEach((item) => {
      if (item.computedCart) {
        if (item.computedCart.xNum >= item.giftInfo.xNum) {
          const maxYNum = item.automaticDiscount.usesPerOrderLimit || 0;
          const ruleXNum = item.giftInfo.xNum;
          const ruleYNum = item.giftInfo.yNum;
          const shouldYNum =
            Math.floor(item.computedCart.xNum / ruleXNum) * ruleYNum;
          const nowYNum = item.computedCart.yNum;
          const shouldAddNum = shouldYNum - nowYNum;
          console.log({
            item,
            ruleXNum,
            ruleYNum,
            shouldYNum,
            nowYNum,
            shouldAddNum,
          });

          if (shouldAddNum > 0 && maxYNum && nowYNum < maxYNum) {
            const goods = this.getAllGetsCanBuys(item);
            const randomGoods = [];
            while (randomGoods.length < shouldAddNum) {
              const randomIndex = getRandomInt(0, goods.length - 1);
              const randomGood = goods[randomIndex];
              randomGoods.push(randomGood);
            }
            tempCart.push(
              ...randomGoods.map((good) => ({
                product_id: good.product_id,
                id: good.id,
                quantity: 1,
              }))
            );
          }
        }
      }
    });
    console.log({ tempCart });
    if (tempCart.length > 0) {
      const response = await fetch("".concat(window.routes.cartAddUrl, ".js"), {
        body: JSON.stringify({ items: tempCart }),
        credentials: "same-origin",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
        },
      });
      if (response.ok) {
        const data = await response.json();
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
        console.log("add to cart success");
      }
    }
  },
};

// 买赠 js end

function generateUUID() {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
// new product track
function h2dTrack(evt, content) {
  const app_name = "BambuShopify";
  const ua = navigator.userAgent;
  const store_location = "JP";
  let os_identifier = localStorage.getItem("os_identifier");
  if (!os_identifier) {
    os_identifier = generateUUID();
    localStorage.setItem("os_identifier", os_identifier);
  }
  const uid = window.customerId;
  const page_url = window.location.href;
  const now = new Date();
  const ts1 = now.getTime();
  const ts2 = now.toISOString();
  const data = [
    {
      app_name: app_name,
      ua: ua,
      store_location: store_location,
      os_identifier: os_identifier,
      uid: uid,
      page_url: page_url,
      evt: evt,
      ts1: ts1,
      ts2: ts2,
      content: content,
      sv: 1,
    },
  ];
  // console.log({data});
  // const requestUrl = "https://event-pre.bambulab.net/web/shop";
  const requestUrl = "https://event.bblmw.com/web/shop";
  fetch(requestUrl, {
    headers: {
      "Content-Type": "application/json",
    },
    method: "post",
    body: JSON.stringify(data),
    keepalive: true,
  });
}
function h2dTrackBannerClick(content) {
  h2dTrack("h2d_product_detail_click", content);
}
function h2dTrackImpression(content) {
  h2dTrack("h2d_product_detail_module_exp", content);
}
function AmsProTrackImpression(content) {
  h2dTrack("amspro_product_detail_module_exp", content);
}
function AmsHTTrackImpression(content) {
  h2dTrack("amsht_product_detail_module_exp", content);
}

window.addEventListener("DOMContentLoaded", function () {
  const newProductsDoms = document.querySelectorAll(".js-h2d-track");
  if (window.IntersectionObserver) {
    const h2dObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const classList = entry.target.classList;
            const chapterClasses = Array.from(classList).filter((cls) =>
              cls.startsWith("js-chapter-")
            );
            const chapterClass =
              chapterClasses.length > 0 ? chapterClasses[0] : "";
            const module = chapterClass.replace("js-chapter-", "");
            if (classList.contains("js-h2d-impression")) {
              const content = {
                module: module,
                seo_code: "H2D",
              };
              h2dTrackImpression(content);
            } else if (classList.contains("js-amsPro-impression")) {
              const content = {
                module: module,
                seo_code: "AMSPro",
              };
              AmsProTrackImpression(content);
            } else if (classList.contains("js-amsHT-impression")) {
              const content = {
                module: module,
                seo_code: "AMSHT",
              };
              AmsHTTrackImpression(content);
            }
            h2dObserver.unobserve(entry.target);
          }
        });
      },
      {
        rootMargin: "-70px 0px",
        threshold: 0,
      }
    );
    newProductsDoms.forEach((newProductDom) => {
      h2dObserver.observe(newProductDom);
    });
  } else {
  }

  // video 需要滚动到 video 30% 的位置才播放
  const videoDoms = document.querySelectorAll(".lazy-play-video");
  if (window.IntersectionObserver) {
    const videoObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const video = entry.target;
            video.play();
            videoObserver.unobserve(video);
          }
        });
      },
      {
        rootMargin: "0px 0px -62px 0px",
        threshold: 0.3,
      }
    );
    videoDoms.forEach((video) => {
      videoObserver.observe(video);
    });
  } else {
    videoDoms.forEach((video) => {
      video.play();
    });
  }

  // 滚动方向检测变量
  let lastScrollTop = 0;
  let scrollDirection = "down"; // 'down' 或 'up'
  let ticking = false;

  // 节流函数 - 使用更长的节流时间减少性能消耗
  function throttleScroll() {
    if (!ticking) {
      requestAnimationFrame(function () {
        const currentScrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        scrollDirection = currentScrollTop > lastScrollTop ? "down" : "up";
        lastScrollTop = currentScrollTop;
        ticking = false;
      });
      ticking = true;
    }
  }

  // 监听滚动事件来检测滚动方向（使用节流优化性能）
  window.addEventListener("scroll", throttleScroll, { passive: true });

  // 动画
  const animationDoms = document.querySelectorAll(".common-animation-section");
  if (window.IntersectionObserver) {
    const animationObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 向下滚动时，触发动画，向上滚动时，不触发动画，但是需要保持动画效果
            if (scrollDirection === "down") {
              // 向下滚动：执行动画
              entry.target.classList.add("active");
              entry.target.classList.remove("staticActive");
            } else {
              // 向上滚动：直接显示动画最终结果
              entry.target.classList.remove("active");
              entry.target.classList.add("staticActive");
            }
          } else {
            entry.target.classList.remove("active");
            entry.target.classList.remove("staticActive");
          }
        });
      },
      {
        rootMargin: "-70px 0px",
        threshold: 0,
      }
    );
    animationDoms.forEach((animationDom) => {
      animationObserver.observe(animationDom);
    });
  } else {
    animationDoms.forEach((animationDom) => {
      animationDom.classList.add("active");
    });
  }
  const animationContentDoms = document.querySelectorAll(
    ".common-animation-content"
  );
  if (window.IntersectionObserver) {
    const animationContentObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 向下滚动时，触发动画，向上滚动时，不触发动画，但是需要保持动画效果
            if (scrollDirection === "down") {
              // 向下滚动：执行动画
              entry.target.classList.add("active");
              entry.target.classList.remove("staticActive");
            } else {
              // 向上滚动：直接显示动画最终结果
              entry.target.classList.remove("active");
              entry.target.classList.add("staticActive");
            }
          } else {
            entry.target.classList.remove("active");
            entry.target.classList.remove("staticActive");
          }
        });
      },
      {
        rootMargin: "-70px 0px",
        threshold: 0,
      }
    );
    animationContentDoms.forEach((animationContentDom) => {
      animationContentObserver.observe(animationContentDom);
    });
  } else {
    animationContentDoms.forEach((animationContentDom) => {
      animationContentDom.classList.add("active");
    });
  }
});

function swiperScrollAutoPlay(swiperSelector, swiperRef, positionPrecent) {
  const swiperDom = document.querySelector(swiperSelector);
  swiperRef.autoplay.stop();
  if (window.IntersectionObserver) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            console.log("trigger swiper auto play");
            swiperRef.autoplay.start();
            observer.unobserve(swiperDom);
          }
        });
      },
      {
        rootMargin: "-70px 0px",
        threshold: positionPrecent || 0.8,
      }
    );
    observer.observe(swiperDom);
  } else {
    swiperRef.autoplay.start();
  }
}
